import FeaturesCard from './components/FeaturesCard';
export default {
  name: 'features',
  components: {
    FeaturesCard
  },
  props: {
    featuresList: {
      type: Array,
      default: () => []
    }
  }
};